import { EnquiryForm } from "./EnquiryForm";
import { FORMS } from "./formConfig";

export default function IndustryForm() {
  return <EnquiryForm config={FORMS.industry} />;
}
